import React from "react";
import BaseModal from "../../../../components/ui/BaseModal";
import BillingRates from "../../../CompleteYourProfile/Forms/BillingRates";

const AddEditBillingRatesModal = ({
  open,
  close,
  userBillingRates,
  refetchMe,
  userId,
  authRole,
  address,
}) => {
  return (
    <BaseModal
      className="-top-[200px] overflow-auto"
      open={open}
      close={close}
      style={{ width: "1060px" }}
    >
      <div className="py-4 px-8">
        <div className="flex justify-between items-center border-b-2 pb-1">
          <h5 className="text-dark font-normal">Billing Rates</h5>
        </div>
      </div>

      <div className="px-4 pb-4">
        <BillingRates
          userBillingRates={userBillingRates}
          refetchMe={refetchMe}
          userId={userId}
          close={close}
          authRole={authRole}
          address={address}
          mode="USER_SETTINGS"
        />
      </div>
    </BaseModal>
  );
};

export default AddEditBillingRatesModal;
